import { createContext } from "react"

const PermissionsContext = createContext({
  permissionsRequired: true,
  permissions: []
})

export { PermissionsContext }
